enum TabMode {
    VESSELS = 0,
    SETTINGS = 1,
}

export default TabMode;